import React from 'react';
import { WeatherIcon } from 'assets/icons/WeatherIcon';
import Draggable from 'components/drag-and-drop/Draggable';
import { Brikk } from 'components/Brikk';
import { BrikkModal } from 'components/modals/BrikkModal';
import { SeeMoreButton } from 'components/form-elements/buttons/SeeMoreButton';
import { useWeather } from 'services/weather';
import { WeatherModal, WeatherPreview } from './components';

export const Weather = ({ position, status, code, name }) => {
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const { weather, isLoading, isError } = useWeather();

  const handleOpenModal = (e) => {
    e.stopPropagation();
    setIsModalOpen(true);
  };

  return (
    <>
      <Draggable position={position}>
        <Brikk
          isLoading={isLoading}
          brikkKey={code}
          name={name}
          status={status}
        >
          <Brikk.Header
            icon={<WeatherIcon />}
            heading="weatherBrikk"
            brikkKey={code}
            status={status}
          />

          <Brikk.Content>
            <WeatherPreview
              weather={weather}
              error={isError}
            />
          </Brikk.Content>

          <Brikk.Button>
            <SeeMoreButton
              onClick={handleOpenModal}
              disabled={!!isError}
              brikkNameIntl="weather"
            />
          </Brikk.Button>
        </Brikk>
      </Draggable>

      <BrikkModal
        isOpen={isModalOpen}
        heading="weather"
        onClose={() => setIsModalOpen(false)}
      >
        <WeatherModal />
      </BrikkModal>
    </>
  );
};
